{
	"_lang": "de",
	"archive": {
		 "playlists": "Eartunes",
		 "userPlaylists": "Eigene Eartunes",
		 "radio": "Eartunes Radio",
		 "archive": "Musik-Archiv"
	},
	"btn": {
		"save": "Speichern",
		"delete": "Löschen",
		"mkdir": "Neuer Ordner",
		"ok": "Ok",
		"cancel": "Abbrechen"
	},
	"deletePl": {
		"title": "Playliste löschen",
		"prompt": "Wollen Sie die Playliste wirklich löschen:"
	},
	"deleteFolder": {
		"title": "Ordner löschen",
		"prompt": "Wollen Sie den Ordner wirklich löschen:"
	},
	"list": {
		"archive": "Archiv",
		"artist": "Interpret",
		"title": "Titel",
		"duration": "Dauer"
	},
	"login": {
		"title": "Login",
		"user": "Benutzer:",
		"password": "Passwort:",
		"btn": "Login",
		"error": "Benutzer/Passwort falsch"
	},
	"mkdir": {
		"title": "Ordner erstellen",
		"prompt": "Geben Sie einen Namen für den neuen Ordner ein"
	},
	"savePlaylist": {
		"title": "Playliste speichern",
		"prompt": "Bitte wählen Sie einen Namen und Speicherort für die Playliste"
	},
	"scheduler": {
		"edit": "Bearbeiten",
		"any": "Beliebig",
		"all": "Alle",
		"none": "Keine",
		"add": "Neu",
		"delete": "Löschen",
		"enabled": "Aktiv",
		"weekdays": "Wochentage",
		"startTime": "Startzeit",
		"endTime": "Endzeit",
		"pls": "Playlisten",
		"frequency": "Intervall",
		"startDate": "Startdatum",
		"endDate": "Enddatum",
		"yearly": "Jährlich",
		"mode": "Modus",
		"players": "Player",
		"jingles": "Jingles",
		"volume": "Lautstärke",
		"keepVolume": "Unverändert",
		"days": ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
		"intervalPrompt": "deaktiviert den Eintrag",
		"editTitle": {
			"_": "Scheduler bearbeiten",
			"date": "Datum bearbeiten",
			"jingles": "Jingles bearbeiten",
			"interval": "Intervall bearbeiten",
			"mode": "Modus bearbeiten",
			"players": "Player bearbeiten",
			"playlists": "Playlisten bearbeiten",
			"time": "Zeit bearbeiten",
			"volume": "Lautstärke bearbeiten",
			"weekdays": "Wochentage bearbeiten"
		},
		"modes": {
			"playOne": "Eines spielen",
			"playInOrder": "Sortiert spielen",
			"playNow": "Sofort spielen",
			"disabled": "Deaktiviert"
		}
	},
	"settings": {
		"editSoundcard": "Soundkarte bearbeiten"
	},
	"conn": {
		"loading": "lädt...",
		"lost": "Verbindung verloren",
		"reconnecting": "verbindungsaufbau..."
	},
	"users": {
		"title": "Web-Benutzer",
		"new": "Neuer Benutzer",
		"delete": "Löschen",
		"name": "Benutzer",
		"pwd": "Passwort",
		"pwdConfirm": "Bestätigen",
		"group": "Gruppe",
		"players": "Player",
		"btnCreate": "Erstellen",
		"plDir": {
			"_": "Playlist-Ordner",
			"title": "Playlist-Ordner auswählen",
			"prompt": "Der neue Benutzer sieht nur den gewählten Ordner"
		}
	}
}
